import React, { Fragment, Component } from 'react'
import {
    FormGroup,
    Separator,
    KioskSelection,
    ActionLink,
} from './MenuSettings'
import PropTypes from 'prop-types'
import Checkbox from '../../components/Checkbox'
import { Link, ButtonDiv, LineWrapper, Button } from './WinrestForm'
import PicturePicker from '../../components/PicturePicker/PicturePicker'
import { SAVED_RECIPES_PICTURES_EXCEL } from './AdminPanel'

import Settings from 'settings'

class ExcelForm extends Component {
    state = {}

    componentDidUpdate() {
        if (this.props.displayMode === 'week' && this.props.startDay === 'today') {
            this.props.handleChange({ target: { name: 'startDay', type: 'select', value: 'monday' }})
        }
    }

    render = () => {
        const {
            entityId,
            siteId,
            file,
            concept,
            forceToday,
            date,
            language,
            service,
            menu,
            kiosks,
            displayMode,
            dayCount,
            orientation,
            zoom,
            size,
            useCommercialName,
            hideComposition,
            hideLabels,
            isDuoKiosk,
            startDay,
            handleChange,
            print,
            maxDate,
            minDate,
            menus,
            days,
            concepts,
            services,
            languages,
            displayModes,
            openPrintDialog,
            generateUrl,
            hideMenuPrice,
            hideRecipePoints,
            title,
            subtitle,
            showDate,
            setExcludedDays,
        } = this.props

        const defaultTitle =
            Settings.translations[
                language && language.indexOf('commercialName') === -1
                    ? language
                    : 'fr'
            ].today

        return (
            <Fragment>
                <FormGroup>
                    <label>Entity:</label>
                    <input
                        name="entityId"
                        type="text"
                        value={entityId}
                        onChange={handleChange}
                    />
                </FormGroup>
                <FormGroup>
                    <label>Site:</label>
                    <input
                        name="siteId"
                        type="text"
                        value={siteId}
                        onChange={handleChange}
                    />
                </FormGroup>
                <FormGroup>
                    <label>Concept:</label>
                    <select
                        name="concept"
                        value={concept}
                        onChange={handleChange}
                    >
                        <option value=""></option>
                        {concepts.map((concept, index) => (
                            <option value={concept.code} key={index}>
                                {concept.name}
                            </option>
                        ))}
                    </select>
                </FormGroup>
                <FormGroup>
                    <label>File:</label>
                    <input
                        name="file"
                        type="text"
                        value={file}
                        onChange={handleChange}
                    />
                </FormGroup>
                <Separator />
                <FormGroup>
                    <label>Service:</label>
                    <select
                        name="service"
                        value={service}
                        onChange={handleChange}
                    >
                        {services.map((service, index) => (
                            <option value={service} key={index}>
                                {service}
                            </option>
                        ))}
                    </select>
                </FormGroup>
                <FormGroup>
                    <label>Language:</label>
                    <select
                        name="language"
                        value={language}
                        onChange={handleChange}
                    >
                        {languages.map((language, index) => (
                            <option value={language} key={index}>
                                {language}
                            </option>
                        ))}
                    </select>
                </FormGroup>
                <FormGroup>
                    <label>Title:</label>
                    <input
                        name="title"
                        type="title"
                        value={title}
                        onChange={handleChange}
                        placeholder={defaultTitle}
                    />
                </FormGroup>
                <FormGroup>
                    <label>Sub title:</label>
                    <input
                        name="subtitle"
                        type="subtitle"
                        value={subtitle}
                        onChange={handleChange}
                    />
                </FormGroup>
                <Separator />
                {displayMode === 'kiosk' && dayCount && (
                    <FormGroup>
                        <label>Menu:</label>
                        <select
                            name="menu"
                            value={menu}
                            onChange={handleChange}
                        >
                            {menus.map((menu, index) => (
                                <option value={menu} key={index}>
                                    {menu}
                                </option>
                            ))}
                        </select>
                    </FormGroup>
                )}

                <FormGroup>
                    <label>Hide menu price:</label>
                    <div>
                        <Checkbox
                            name="hideMenuPrice"
                            type="checkbox"
                            checked={hideMenuPrice}
                            onAction={handleChange}
                        />
                    </div>
                </FormGroup>

                <FormGroup>
                    <label>Hide recipe points:</label>
                    <div>
                        <Checkbox
                            name="hideRecipePoints"
                            type="checkbox"
                            checked={hideRecipePoints}
                            onAction={handleChange}
                        />
                    </div>
                </FormGroup>

                <FormGroup>
                    <label>Use kiosk name:</label>
                    <div>
                        <Checkbox
                            name="useCommercialName"
                            type="checkbox"
                            checked={useCommercialName}
                            onAction={handleChange}
                        />
                    </div>
                </FormGroup>
                <FormGroup>
                    <label>Hide composition:</label>
                    <div>
                        <Checkbox
                            name="hideComposition"
                            type="checkbox"
                            checked={hideComposition}
                            onAction={handleChange}
                        />
                    </div>
                </FormGroup>
                <FormGroup>
                    <label>Hide labels:</label>
                    <div>
                        <Checkbox
                            name="hideLabels"
                            type="checkbox"
                            checked={hideLabels}
                            onAction={handleChange}
                        />
                    </div>
                </FormGroup>
                {displayMode === 'kiosk' && (
                    <FormGroup>
                        <label>Duo Kiosk:</label>
                        <div>
                            <Checkbox
                                name="isDuoKiosk"
                                type="checkbox"
                                checked={isDuoKiosk}
                                onAction={handleChange}
                            />
                        </div>
                    </FormGroup>
                )}
                <label>Kiosks:</label>
                {menu === '' && (
                    <KioskSelection nogrid>
                        {concept && (
                            <PicturePicker
                                concept={concept}
                                excel
                                handleChange={handleChange}
                                open={this.state.pickReciPic}
                                useCommercialName={useCommercialName}
                                close={() =>
                                    this.setState({
                                        pickReciPic: null,
                                    })
                                }
                            />
                        )}
                        {kiosks.map((item, index) => {
                            const handleCheckbox = e => {
                                const typedKioskPics =
                                    JSON.parse(
                                        localStorage.getItem(
                                            SAVED_RECIPES_PICTURES_EXCEL
                                        )
                                    ) || {}
                                if (item.enabled) {
                                    handleChange(e)
                                } else if (
                                    typedKioskPics[concept] &&
                                    typedKioskPics[concept][item.name]
                                ) {
                                    const newEvent = { ...e }
                                    newEvent.target.name = `kiosk_${index}-${
                                        typedKioskPics[concept][item.name]
                                    }`
                                    handleChange(newEvent)
                                } else if (
                                    themes[concept].kiosks_background[
                                        item.name
                                    ] !== undefined
                                ) {
                                    const newEvent = { ...e }
                                    newEvent.target.name = `kiosk_${index}-${item.name}`
                                    handleChange(newEvent)
                                } else {
                                    this.setState({
                                        pickReciPic: { index, name: item.name },
                                    })
                                }
                            }

                            return (
                                <LineWrapper key={index}>
                                    <div>
                                        <Checkbox
                                            name={`kiosk_${index}`}
                                            type="checkbox"
                                            checked={item.enabled}
                                            onClick={handleCheckbox}
                                            label={item.name}
                                        />
                                    </div>
                                    {item.enabled && (
                                        <Button
                                            onClick={() =>
                                                this.setState({
                                                    pickReciPic: {
                                                        index,
                                                        name: item.name,
                                                    },
                                                })
                                            }
                                        >
                                            Modify
                                        </Button>
                                    )}
                                </LineWrapper>
                            )
                        })}
                    </KioskSelection>
                )}

                <Separator />
                <FormGroup>
                    <label>Date:</label>
                    <input
                        name="date"
                        type="date"
                        value={date}
                        onChange={handleChange}
                        min={minDate}
                        max={maxDate}
                        readOnly={minDate === maxDate || forceToday}
                    />
                </FormGroup>
                <FormGroup title="The link will be generated with the {today} token to automatically display the menu of the current day">
                    <label>Current date:</label>
                    <div>
                        <Checkbox
                            name="forceToday"
                            type="checkbox"
                            value={forceToday}
                            checked={forceToday}
                            onAction={handleChange}
                        />
                    </div>
                </FormGroup>
                {menu === '' && minDate !== maxDate && (
                    <FormGroup>
                        <label>Day count:</label>
                        <input
                            name="dayCount"
                            type="number"
                            value={dayCount}
                            onChange={handleChange}
                            disabled={displayMode === 'print'}
                            min="1"
                        />
                    </FormGroup>
                )}
                {menu === '' && minDate !== maxDate && (
                    <FormGroup>
                        <label>Start day</label>
                        <select
                            name="startDay"
                            value={startDay}
                            onChange={handleChange}
                        >
                            {days.map((day, index) => (
                                <option value={day} key={index} disabled={displayMode === 'week' && day === 'today'}>
                                    {day}
                                </option>
                            ))}
                        </select>
                    </FormGroup>
                )}
                {dayCount > 1 && (
                    <FormGroup>
                        <label>Excluded days:</label>
                        <select
                            name="excludedDays"
                            style={{ height: '120px' }}
                            multiple
                            onChange={setExcludedDays}
                        >
                            <option value="1">monday</option>
                            <option value="2">tuesday</option>
                            <option value="3">wednesday</option>
                            <option value="4">thurday</option>
                            <option value="5">friday</option>
                            <option value="6">saturday</option>
                            <option value="0">sunday</option>
                        </select>
                    </FormGroup>
                )}
                <Separator />
                <FormGroup>
                    <label>Mode:</label>
                    <select
                        name="displayMode"
                        value={displayMode}
                        onChange={handleChange}
                    >
                        {displayModes.map(
                            (displayMode, index) =>
                                displayMode.visible && (
                                    <option
                                        value={displayMode.value}
                                        key={index}
                                    >
                                        {displayMode.name}
                                    </option>
                                )
                        )}
                    </select>
                </FormGroup>
                {displayMode === 'kiosk' && (
                    <FormGroup>
                        <label>Zoom:</label>
                        <input
                            name="zoom"
                            type="number"
                            step="0.01"
                            value={zoom}
                            onChange={handleChange}
                        />
                        <div />
                        <small>ex: 1.05</small>
                    </FormGroup>
                )}
                {(displayMode === 'kiosk' || displayMode === 'week') && (
                    <FormGroup>
                        <label>Print:</label>
                        <div>
                            <Checkbox
                                name="print"
                                type="checkbox"
                                value={print}
                                checked={print}
                                onAction={handleChange}
                            />
                        </div>
                    </FormGroup>
                )}

                {print && displayMode !== 'week' && (
                    <Fragment>
                        <FormGroup>
                            <label>Orientation:</label>
                            <select
                                name="orientation"
                                value={orientation}
                                onChange={handleChange}
                            >
                                <option value="portrait">Portrait</option>
                                <option value="landscape">Paysage</option>
                            </select>
                        </FormGroup>
                        <FormGroup>
                            <label>Size:</label>
                            <select
                                name="size"
                                value={size}
                                onChange={handleChange}
                            >
                                <option value="A4">A4</option>
                                <option value="A5">A5</option>
                            </select>
                        </FormGroup>
                        <FormGroup>
                            <label>Show date:</label>
                            <div>
                                <Checkbox
                                    name="showDate"
                                    type="checkbox"
                                    value={showDate}
                                    checked={showDate}
                                    onAction={handleChange}
                                />
                            </div>
                        </FormGroup>
                    </Fragment>
                )}
                <ActionLink>
                    <Link
                        href={generateUrl()}
                        target="_blank"
                        rel="noopener noreferrer"
                    >
                        Link
                    </Link>
                    {displayMode !== 'day' && print && (
                        <ButtonDiv onClick={openPrintDialog}>Print</ButtonDiv>
                    )}
                </ActionLink>
            </Fragment>
        )
    }
}

export default ExcelForm

ExcelForm.propTypes = {
    // func
    closeDrawer: PropTypes.func,
    handleChange: PropTypes.func,
    openPrintDialog: PropTypes.func,
    openDrawer: PropTypes.func,
    openPrintDialog: PropTypes.func,
    generateUrl: PropTypes.func,

    // boolean
    settingsDrawerOpen: PropTypes.bool,
    forceToday: PropTypes.bool,
    print: PropTypes.bool,
    useCommercialName: PropTypes.bool,

    // string
    entityId: PropTypes.string,
    file: PropTypes.string,
    concept: PropTypes.string,
    date: PropTypes.string,
    language: PropTypes.string,
    service: PropTypes.string,
    menu: PropTypes.string,
    displayMode: PropTypes.string,
    orientation: PropTypes.string,
    size: PropTypes.string,
    startDay: PropTypes.string,
    dataSource: PropTypes.string,
    minDate: PropTypes.string,
    maxDate: PropTypes.string,
    siteId: PropTypes.string,

    // number
    zoom: PropTypes.number,
    dayCount: PropTypes.number,

    // array
    displayModes: PropTypes.array,
    kiosks: PropTypes.array,
    days: PropTypes.array,
}
